import {
  DEFAULT_LESSON_THEME,
  LESSON_THEMES,
  patternLayer,
  type BlockPatternId,
  type LessonThemeId,
} from '@teach/ui'
import type { ContentLang } from '@/features/editor/editorSlice'
import { PhoneCanvas } from '@/features/editor/components/blocks/previews/PhoneCanvas'
import { PreviewShell } from '@/features/editor/components/blocks/previews/PreviewShell'
import { VIEWPORTS } from '@/features/editor/components/blocks/previews/previewViewports'
import { messages as previewMessages } from '@/features/editor/components/blocks/previews/messages'
import { pickMessages } from '@/i18n'

interface Props {
  theme: LessonThemeId | null
  pattern: BlockPatternId | null
  contentLang: ContentLang
}

/**
 * Пустой экран урока на холсте, пока открыта вкладка «Оформление»: фон и узор как у настоящего
 * блока, полоска прогресса и кнопка. Автор видит выбранное оформление крупно.
 */
export const LessonLookPreview = ({ theme, pattern, contentLang }: Props) => {
  const themeId = theme ?? DEFAULT_LESSON_THEME.id
  const base = (LESSON_THEMES.find((t) => t.id === themeId) ?? DEFAULT_LESSON_THEME).background
  const layer = patternLayer(themeId, pattern)
  const { width, height } = VIEWPORTS.phone
  return (
    <div
      data-testid="lesson-look-preview"
      // Телефон и планшет: панель лежит шторкой поверх холста, экран за ней не нужен.
      className="relative hidden h-full max-w-full lg:block"
      style={{ aspectRatio: `${width} / ${height}` }}
    >
      <PhoneCanvas className="rounded-2xl shadow-sm" viewport="phone">
        <PreviewShell
          cta={pickMessages(previewMessages, contentLang).next}
          style={{ background: layer ? `${layer}, ${base}` : base }}
        >
          <div />
        </PreviewShell>
      </PhoneCanvas>
    </div>
  )
}
